export function NotFoundPage() {
  return (
    <main>
      <h1>404 — Page Not Found</h1>
    </main>
  )
}
